// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accordion{padding-left:24px;padding-right:24px;border:1px solid #d9d9d6;border-radius:12px}@media (max-width:767px){.accordion{padding:8px 16px}}", ""]);
// Exports
module.exports = exports;
